module.exports = __webpack_public_path__ + "img/img_5.232f87bc.png";